define.alias("ember-power-select/helpers/ember-power-select-is-selected-present", "settings/helpers/ember-power-select-is-selected-present");